import ApiAdmin from './config/ApiAdmin'
import _ from 'lodash'

const QuestionsService = {

  createQuestion (testId, question) {
    return ApiAdmin.post(`/tests/${testId}/questions`, question)
  },

  patchQuestion (testId, question, onUploadProgress) {
    let newQuestion = _.clone(question, true)
    delete newQuestion.question_answers
    return ApiAdmin.patch(`/tests/${testId}/questions/${question.id}`,
      newQuestion,
      {
        onUploadProgress: onUploadProgress
      }
    )
  },

  deleteQuestion (testId, questionId) {
    return ApiAdmin.delete(`/tests/${testId}/questions/${questionId}`)
  },

  patchAnswer (testId, questionId, answer, onUploadProgress) {
    return ApiAdmin.patch(
      `/tests/${testId}/questions/${questionId}/answers/${answer.id}`,
      answer,
      {
        onUploadProgress: onUploadProgress
      }
    )
  },

  createAnswer (testId, questionId, answer, onUploadProgress) {
    return ApiAdmin.post(
      `/tests/${testId}/questions/${questionId}/answers`,
      answer,
      {
        onUploadProgress: onUploadProgress
      }
    )
  },

  deleteAnswer (testId, questionId, answerId, onUploadProgress) {
    return ApiAdmin.delete(
      `/tests/${testId}/questions/${questionId}/answers/${answerId}`,
      {
        onUploadProgress: onUploadProgress
      }
    )
  }

}
export default QuestionsService



// WEBPACK FOOTER //
// ./src/services/QuestionsService.js